import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  loading: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "999",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: 1,
    // backgroundColor: "white",
  },
  loading2: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "9999",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: 1,
    // backgroundColor: "white",
  },
  loading3: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "999",
    top: 0,
    left: 350,
    width: "calc(100% - 350px)",
    height: "100%",
    opacity: 1,
    // backgroundColor: "white",
  },
  background: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "white",
    opacity: 0.9,
    zIndex: 1
  },
  icon: {
    height: "3.5rem",
    zIndex: 2
  },
  content:{
    backgroundColor: "transparent",
    padding: "10px",
    zIndex: 2
  },
  cardContent: {
    textAlign: "center",
  },
});
